const nb = {
  kicker: "For lokale bedrifter og huseiere",
  title: "Bli vert i Trollfossjakten.",
  lead: "En vert er en lokal bedrift eller huseier langs løypa mellom Lavangen og Årstein (Gratangen) — en kafé, gård, hytte, B&B, badstue eller butikk. Verter tar imot trolljaktgjester og godtar Trollkroner (TK), spillets egne penger, som betaling.",
  badges: ["Gratis", "Ca. 2 minutter", "Live på kartet med en gang"],
  waysKicker: "To måter å være med på",
  waysTitle: "Velg én — eller begge.",
  ways: [
    { title: "Vertssted", tag: "Tar imot Trollkroner", body: "Du vises på kartet, og gjestene kan betale deg med TK-ene i lommeboka si." },
    { title: "Rasteplass", tag: "Kun oppføring", body: "En kartnål som viser tjenestene dine, som lading av bil eller sykkel, dusj, matmeny, B&B, camping, wifi, parkering, toalett og kaffe. Gratis synlighet — ingen penger håndteres." },
  ],
  both: "Du kan gjøre begge deler.",
  joinKicker: "Slik blir du vert",
  joinTitle: "Ca. 2 minutter, og gratis.",
  steps: ["Last ned appen og logg inn.", "Gå til Profil → Bli vert → Registrer deg som vert.", "Fyll inn opplysningene dine (se lista).", "Ferdig — du er live på kartet med en gang."],
  formTitle: "Dette fyller du inn",
  fields: [["Bedriftsnavn", "obligatorisk"], ["Adresse", "obligatorisk"], ["Telefon", "valgfritt"], ["Hva du tilbyr", "f.eks. «kaffe, vafler, badstue»"]],
  amenitiesTitle: "Fasilitetene dine",
  noWait: "Ingen ventetid på godkjenning og ingen påmeldingsavgift.",
  pitTitle: "Legge til en rasteplass",
  pitBody: "Gå til Profil → Bli rasteplass → Registrer rasteplass, og fyll inn navn, adresse, telefon, plassering på kartet og fasiliteter.",
  tkKicker: "Slik fungerer Trollkroner",
  tkTitle: "1 TK = 1 krone.",
  tkEarnTitle: "Gjestene tjener TK ved å",
  tkEarn: ["invitere venner — de får 50 % tilbake av en venns første passkjøp", "nå Arrow Hunter-rangbonuser: +10 / +25 / +100 TK", "snurre premiehjulet"],
  tkRule: "TK kan bare brukes hos registrerte verter. Gjestene kan ikke ta dem ut som penger.",
  payKicker: "Ta imot betaling",
  payTitle: "Vertspanelet regner for deg.",
  paySteps: ["Gjesten åpner Profil → Vis betalings-QR.", "Du skanner den eller skriver inn lommebokkoden (TK-XXXXXX).", "Skriv inn beløpet i kroner og hva de kjøpte, f.eks. «kaffe og vafler».", "Appen trekker så mye som mulig fra TK-saldoen og viser resten du tar betalt kontant eller med kort."],
  exampleTitle: "Eksempel",
  example: { note: "Kjøp på 85 kr, 60 TK i lommeboka", total: "Kjøp", tk: "Betalt med TK", rest: "Tas betalt kontant eller med kort" },
  dashboard: "Panelet ditt viser hvert salg, pluss TK mottatt i dag og totalt.",
  ctaTitle: "Klar til å ta imot trollgjester?",
  ctaBody: "Last ned appen, logg inn og registrer deg som vert — det tar ca. to minutter.",
  cta: "Last ned appen",
  ctaPartner: "Vil du ha egne troll også? Se partnerpakkene",
  ctaHost: "Registrer deg som vert",
  webNote: "Vil du heller bruke nettsiden? Registrer deg her — marker stedet ditt på kartet, fortell hva du tilbyr og huk av fasilitetene dine.",
};

export default nb;
